import { useParams } from 'react-router-dom';
import { ModelDetailView } from "../_components";

export default function ContentModelDetailPage() {
  const params = useParams();
  const slug = typeof params.slug === "string" ? params.slug : "";

  return <ModelDetailView speciesSlug={slug} />;
}
